"use client";
import { ThreeDMarquee } from "../ui/3d-marquee";

export function ThreeDMarqueeDemoSecond() {
  const images = [
    "collegeService_1.jpg",
    "collegeService_2.jpg",
    "collegeService_3.jpg",
    "collegeService_5.jpg",
    "collegeService_7.jpg",
    "collegeService_8.jpg",
    "collegeService_GroupDiscussion_10.jpg",
    "collegeService_MockDiscussion_6.jpg",
    "collegeService_Resume_4.jpg",
    "collegeService_1.jpg",
    "collegeService_2.jpg",
    "collegeService_3.jpg",
    "collegeService_5.jpg",
    "collegeService_7.jpg",
    "collegeService_8.jpg",
    "collegeService_GroupDiscussion_10.jpg",
    "collegeService_MockDiscussion_6.jpg",
    "collegeService_Resume_4.jpg",
    "collegeService_1.jpg",
    "collegeService_2.jpg",
    "collegeService_3.jpg",
    "collegeService_5.jpg",
    "collegeService_7.jpg",
    "collegeService_8.jpg",
    "collegeService_GroupDiscussion_10.jpg",
    "collegeService_MockDiscussion_6.jpg",
    "collegeService_Resume_4.jpg",
    "collegeService_1.jpg",
    "collegeService_2.jpg",
    "collegeService_3.jpg",
    "collegeService_5.jpg",
    "collegeService_7.jpg",
  ];

  const scrollToBooking = () => {
    // console.log("Button clicked"); // Debug log
    const section = document.getElementById("service-college-section");
    // console.log("Section found:", section); // Debug log

    if (section) {
      section.scrollIntoView({ block: "start", behavior: "smooth" });
    } else {
      console.error('Section with id "booking-section" not found!');
    }
  };
  return (
    <div className="relative flex h-screen w-full max-w-full flex-col items-center justify-center overflow-hidden overflow-x-hidden">
      <h2 className="relative z-20 mx-auto max-w-4xl text-center text-2xl font-bold text-balance text-white md:text-4xl lg:text-6xl">
        Bring{" "}
        <span className="relative z-20 inline-block rounded-xl bg-blue-500/40 px-4 py-1 text-white  decoration-sky-500 decoration-[6px] underline-offset-[16px] backdrop-blur-sm">
          Off-Campus
        </span>{" "}
        to Your College –{" "}
        {/* <span className="relative z-20 inline-block rounded-xl bg-blue-500/40 px-4 py-1 text-white underline decoration-sky-500 decoration-[6px] underline-offset-[16px] backdrop-blur-sm">
          Training
        </span>{" "} */}
        Training That Gets Students Hired.
      </h2>
      <p className="relative z-20 mx-auto max-w-2xl py-8 text-center text-sm text-neutral-200 md:text-base">
        Workshops, sessions, and 1:1 mentoring trusted by 5000+ students across
        India
      </p>
      <div className="relative z-30 flex flex-wrap items-center justify-center gap-4 pt-4">
        <button
          onClick={scrollToBooking}
          className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-3 font-medium text-white shadow-lg transition-all duration-300 hover:-translate-y-[-2px] hover:shadow-xl"
        >
          <div
            className="absolute -inset-[2px] rounded-lg"
            style={{
              background:
                "conic-gradient(from 0deg, #3b82f6, #8b5cf6, #3b82f6, transparent, transparent, transparent, transparent, transparent)",
              animation: "spin 2s linear infinite",
            }}
          ></div>
          <div className="absolute inset-[2px] rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600"></div>
          <span className="relative z-10 flex items-center gap-2 text-sm font-semibold">
            Book A Session For Your College
          </span>
        </button>
        {/* <button
          className="rounded-md border border-white/20 bg-white/10 px-6 py-2.5 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20 focus:ring-2 focus:ring-white/20 focus:ring-offset-2 focus:ring-offset-black focus:outline-none">
          Read more
        </button> */}
      </div>
      {/* overlay */}
      <div className="absolute inset-0 z-10 h-full w-full bg-black/80 dark:bg-black/40" />
      <ThreeDMarquee
        className="pointer-events-none absolute inset-0 h-full w-full"
        images={images}
      />
    </div>
  );
}
